import { Component, Input, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { LookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-form-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule,
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormPickerComponent),
      multi: true
    }
  ]
})
export class FormPickerComponent extends BasePickerComponent<LookupItem> {

 @Input() publishedOnly: boolean = true;
 @Input() forCopy: boolean = false;
  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<LookupItem>> {
    return this.lookupService.getForms(this.publishedOnly, undefined, query, 20, this.forCopy);
  }

  override load(keys: string[]): Observable<ListResult<any>> {this
    return this.lookupService.getForms(undefined, keys);
  }
}
